/**
 * Constants for ContentManagerAccess component
 */

export const ROUTES = {
    ACCESS_CONTENT_MANAGER: "/access-content-manager",
    CONTENT_MANAGER: "/content-manager",
} as const;

export const API_ENDPOINTS = {
    AUTH_LOGIN: "/api/auth/login",
} as const;

export const AUTH_CALLBACK_PARAMS = {
    CODE: "code=",
    ERROR: "error=",
} as const;

export const DEFAULT_LIST_ID = "editorial_root";

/**
 * Colors
 */
export const COLORS = {
    TEXT_SECONDARY: "#8B92A6",
    TEXT_TERTIARY: "#888",
    PRIMARY_GRADIENT_START: "#00aaff",
    PRIMARY_GRADIENT_END: "#0088cc",
    PRIMARY_HOVER_START: "#0099ee",
    PRIMARY_HOVER_END: "#0077bb",
    ERROR_TEXT: "#ff8a8a",
    ERROR_BG: "rgba(255, 82, 82, 0.1)",
    ERROR_BORDER: "rgba(255, 82, 82, 0.3)",
    PRIMARY_SHADOW: "rgba(0, 170, 255, 0.3)",
    PRIMARY_SHADOW_HOVER: "rgba(0, 170, 255, 0.4)",
} as const;

/**
 * Spacing
 */
export const SPACING = {
    MARGIN_TOP_HEADING: "24px",
    MARGIN_BOTTOM_HEADING: "12px",
    MAX_WIDTH_TEXT: "420px",
    BUTTON_PADDING: "0.9rem",
    ERROR_PADDING_VERTICAL: "0.8rem",
    ERROR_PADDING_HORIZONTAL: "1rem",
    MARGIN_TOP_BUTTON: "1.5rem",
    MARGIN_TOP_ERROR: "1rem",
    MARGIN_TOP_FOOTER: "1.5rem",
    MARGIN_BOTTOM_TEXT: "2rem",
} as const;

/**
 * Typography
 */
export const TYPOGRAPHY = {
    FONT_SIZE_BODY: "15px",
    FONT_SIZE_BUTTON: "1.1rem",
    FONT_SIZE_ERROR: "0.9rem",
    FONT_SIZE_FOOTER: "0.85rem",
    LINE_HEIGHT_BODY: "1.6",
    LINE_HEIGHT_FOOTER: "1.5",
    FONT_WEIGHT_BUTTON: "600",
} as const;

/**
 * Button styles
 */
export const BUTTON_STYLES = {
    BORDER_RADIUS: "8px",
    SHADOW_BLUR: "12px",
    SHADOW_BLUR_HOVER: "16px",
    SHADOW_SPREAD: "4px",
    SHADOW_SPREAD_HOVER: "6px",
    TRANSFORM_HOVER: "translateY(-2px)",
    TRANSFORM_DEFAULT: "translateY(0)",
} as const;

/**
 * Spinner
 */
export const SPINNER = {
    VIEWBOX_SIZE: "50 50",
    CENTER_X: 25,
    CENTER_Y: 25,
    RADIUS: 20,
    STROKE_WIDTH: 4,
} as const;

/**
 * Feedback messages
 */
export const MESSAGES = {
    LOADING_AUTH: "Loading...",
    SETTING_UP_SESSION: "Setting Up Your Session...",
    CHECKING_AUTH_STATUS: "Checking authentication status...",
    SESSION_SETUP_DESCRIPTION:
        "Please wait while we authenticate your credentials and set up your session.",
    AUTHENTICATED_TITLE: "Authenticated",
    AUTHENTICATED_MESSAGE: "You are logged in. Redirecting to content manager...",
    SIGN_IN_TITLE: "Access The Curator",
    SIGN_IN_DESCRIPTION: "Sign in with your Vimond account to continue",
    SIGN_IN_BUTTON: "Sign In with Auth0",
} as const;
